export var ShopperFulfilmentDetails;
(function (ShopperFulfilmentDetails) {
    ShopperFulfilmentDetails.PerishableCodeEnum = {
        P: 'P',
        L: 'L',
        N: 'N'
    };
})(ShopperFulfilmentDetails || (ShopperFulfilmentDetails = {}));
